(function ($, Drupal) {
  "use strict";
  // Strictly load recpatcha in compact mode in mobile sizes to prevent overflow on side form

  Drupal.behaviors.responsiveRecaptcha = {
    attach: function (context, settings) {
      $(".g-recaptcha", context).each(function () {
        if (!$(this).hasClass("responsiveRecaptcha-processed")) {
          $(this).addClass("responsiveRecaptcha-processed");
          if (window.innerWidth <= 400) {
            $(this).attr("data-size", "compact");
          }
        }
      });
    },
  };
})(jQuery, Drupal);
